$(document).ready(function () {
  // Email share button
  $(".share-email-button").on("click", function (e) {
    e.preventDefault();

    var subject = "Hey! Check out this new post on lumosfiber.com";
    var body =
      "Hey! Check out this new post on lumosfiber.com: " + window.location.href;
    window.location.href =
      "mailto:?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body);
  });

  // Copy to clipboard button
  $(".share-copy-button").on("click", function (e) {
    e.preventDefault();

    navigator.clipboard.writeText(window.location.href).then(
      function () {
        // Show the alert and then fade it out
        var $alert = $(this).siblings(".alert");
        $alert.removeClass("d-none").addClass("show");
        setTimeout(function () {
          $alert.fadeOut(300, function () {
            $alert.addClass("d-none").removeClass("show").css("display", ""); // reset the display property after fadeOut
          });
        }, 3000);
      }.bind(this),
      function (err) {
        console.error("Failed to copy text: ", err);
      }
    );
  });
});
